// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".animate-forward[data-v-2b982694] {\n  -webkit-animation-fill-mode: forwards !important;\n          animation-fill-mode: forwards !important;\n}\n.required-icon[data-v-2b982694] {\n  color: #ff766e;\n  margin-right: 4px;\n}", ""]);
// Exports
module.exports = exports;
